module.exports = __webpack_public_path__ + "media/images/C_W Letterhead-5b81a068007d55a289cbab7888a99515.png";